import { render, staticRenderFns } from "./GlobalChatpersonsPage.vue?vue&type=template&id=5781fea2&scoped=true&"
import script from "./GlobalChatpersonsPage.vue?vue&type=script&lang=js&"
export * from "./GlobalChatpersonsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5781fea2",
  null
  
)

export default component.exports